import { ZustandStore } from "../../../store/zustand-store";
import { useMemo } from "react";

export const useTableBlur = ({ currentPage = 0, blurFromPage = 3 }) => {
  const { customer_plan } = ZustandStore((state) => state);

  const { isTrialUser, showWarning } = useMemo(() => {
    const createdAt = customer_plan?.created_at;
    const createdDate = createdAt ? new Date(createdAt) : null;
    const todayDate = new Date("2025-06-25");

    const isCreatedAfterToday = createdDate?.getTime() > todayDate.getTime();
    const isFreeUser = customer_plan?.status === "Free";
    const isTrial = customer_plan?.status === "trialing";

    const adjustedBlurFromPage = isFreeUser ? 1 : blurFromPage;
    const isTrialUser = isTrial && isCreatedAfterToday;
    const isFullTableAccess = isTrialUser || isFreeUser;

    const showWarning =
      isFullTableAccess && currentPage >= adjustedBlurFromPage;

    return { isTrialUser, showWarning };
  }, [customer_plan, currentPage, blurFromPage]);

  return { isTrialUser, showWarning };
};
